// routes/_authenticated/ranking.tsx — entry point for the `/ranking` page.
// The page itself lives in `@/features/ranking/index.tsx`; this file is just
// the router glue.
import { createFileRoute } from "@tanstack/react-router";

import { RankingPage } from "@/features/ranking";

export const Route = createFileRoute("/_authenticated/ranking")({
  component: RankingPage,
});
